var aclh_module_masonry = (function (aclh_module_masonry) {



    aclh_module_masonry.init = function(){

      function masonry(grid, gridCell, gridGutter, dGridCol, tGridCol, mGridCol) {

        var grid = $(grid);
        var gridCells = $(gridCell, grid);

        // 1024 and above
        if(window.matchMedia('(min-width:1024px)').matches){
          masonryHeightFixer(dGridCol);
        }
        // 1023 to 666
        if(window.matchMedia('(max-width:1023px) and (min-width:666px)').matches){
          masonryHeightFixer(tGridCol);
        }
        // 666 and below
        if(window.matchMedia('(max-width:665px)').matches){
          $(grid).css('height','auto');
        }


        function masonryHeightFixer(desiredColumns){
          // find out how many rows we'll end up with
          var rows = gridCells.length / desiredColumns;
          console.log('rows',Math.ceil(rows));
          var maxHeight = 0;
          var cols = [];
          // go through each column and work out height
          for(i=0; i<=Math.ceil(rows); ++i) {
            cols[i] = 0;
            var h = 0;
            $.each(gridCells, function(index, val) {
              if((index % desiredColumns)==i) {
                h += $(this).height() + gridGutter;
                console.log($(this));
              }
            });
            cols[i] = Math.max(cols[i],h);
          }
          var highestCol = Math.max.apply(null, cols)
          console.log('highestCol',highestCol);
          $(grid).height(highestCol + 5);
        }


      }





      var masonryGrid = document.querySelector('#aclh-wrapper .aclh-wall-content');
      // masonryGrid.insertAdjacentHTML("afterend", "<div class='aclh-wall-preloader'>Loading...</div>");
      var masonryPreloader = document.querySelector('#aclh-wrapper .aclh-wall-preloader');

      ["resize", "load"].forEach(function(event) {
        console.log('masonry');
        // Adding little preloader information
        masonryGrid.style.display="none";
        window.addEventListener(event, function() {
          imagesLoaded( document.querySelector('#aclh-wrapper .aclh-wall-content'), function() {
            masonryGrid.style.display="flex";
            masonryPreloader.style.display="none";
            masonryGrid.classList.add('loaded');

            // A masonry grid with 8px gutter, with 3 columns on desktop, 2 on tablet, and 1 column on mobile devices.
            masonry("#aclh-wrapper .aclh-wall-content", ".aclh-wall-item", 21, 3, 2, 1);
            // console.log("Loaded");
          });
        }, false);
      });




      window.addEventListener('resize', function(){
        console.log('resize');
        masonry("#aclh-wrapper .aclh-wall-content", ".aclh-wall-item", 21, 3, 2, 1);
      });

      // $( window ).on( "resize", function() {
      //   console.log('resize');
      //   // $( "body" ).prepend( "<div>" + $( window ).width() + "</div>" );
      // } );


    };//end init



    return aclh_module_masonry;
}(aclh_module_masonry || {}));